angular
	.module 'App.Repository'

.factory 'DataSourceRepository', ['BaseRepository', (BaseRepository) ->
		class DataSourceRepository extends BaseRepository
			@resource = '/data_sources'
			@isRestricted = true

		return new DataSourceRepository
	]
